/**
 * Single plan-tier availability cell (check / lock / “Soon”).
 * Shared by Free, Elite, and Prime columns so glyph + a11y label stay consistent.
 */

import type { CompareAvailability } from '../../types/compare.types'
import GreyLockSVG from '../../../../icons/GreyLockSVG'
import { CompareCheckIcon } from '../../icons/CompareCheckIcon'

export function ElitePlansCompareAvailabilityIcon({
  availability,
  checkColor,
  label
}: {
  availability: CompareAvailability
  checkColor: string
  label: string
}) {
  return (
    <span className='flex w-10 items-center justify-center' aria-label={label}>
      {availability === 'check' ? <CompareCheckIcon color={checkColor} /> : null}
      {availability === 'lock' ? <GreyLockSVG /> : null}
      {availability === 'coming-soon' ? (
        <span className='text-[9px] font-medium uppercase leading-[1.1] tracking-[0.4px] text-[#CC5C2D]'>
          Soon
        </span>
      ) : null}
    </span>
  )
}
